import React, {useCallback, useEffect, useState} from 'react';
import TextArea from "./Components/TextArea";
import RightClickMenu from "./Components/RightClickMenu";
import DataComponent from "./Components/DataComponent";
import {Handle, Position} from "react-flow-renderer";


const style = {
    outline: "2px solid orange",
}

const Player = ({data, type, id}) => {


    const [active, setActive] = useState(false)
    const [stl, setStl] = useState({})
    const [menu, showMenu] = useState(false)
    const [customData, setCustomData] = useState([])


    const onDoubleClick = useCallback((event) => {
        setActive(true)
        setStl(style)

    }, [])

    const DisableActive = useCallback((event) => {
        if (!data.isStart) {
            setStl({})
        } else   if (type === "Player")
            setStl({outline: "2px solid rgb(0, 108, 255)"})
        else
            setStl({outline: "2px solid rgb(209, 0, 255)",})
        setActive(false)
        // document.getElementById( 'TextArea' ).scrollTop = 0
        showMenu(false)
    }, [])


    useEffect(() => {
        data.ActivFun = DisableActive
        data.active = onDoubleClick

        if (data.isStart)
            if (type === "Player")
                setStl({outline: "2px solid rgb(0, 108, 255)"})
            else
                setStl({outline: "2px solid rgb(209, 0, 255)",})

        // setCustomData(data.data)
        if(!data.data[0]){
            addData()
        } else {
            let arr = []
            data.data.map((value) => {
                value.setIsOpen = () => {
                }
                arr.push({
                    name: value.name, type: value.type, value: value.value, setIsOpen: () => {
                    }
                })
            })
            setCustomData(arr)
        }

    }, [])

    const addData = () => {
        let arr = customData
        arr.push({
            //index:customData.length
        })
        data.data.push({
            name: "None", type: "None", value: "", setIsOpen: () => {
            }
        })
        setCustomData(arr)
    }

    const removeData = () => {
        let arr = customData
        arr.pop()
        data.data.pop()
        setCustomData(arr)
    }
    return (
    <div
        style={{...stl, }}
        className="text-updater-node"
    >
        <div style={{width:"250px", margin:"10px"}}>Data:</div>
        <Handle className="MainOute" type="source" id="out" style={{ top:"20px"}} position={Position.Right}/>
        <Handle className="MainIne" type="target" id="in" style={{ top:"20px"}} position={Position.Left}/>
        {/*<TextArea data={data} type={type} isFocused={active}/>*/}
        {!active && <div
            onContextMenu={
                event => {
                    event.preventDefault()
                    showMenu(!menu)
                }
            }
            className="Shild"></div>}
        {menu && <RightClickMenu data={data} id={id} showSetStart={false}/>}
        {customData.map((value, index) => <DataComponent type={type} key={index} data={data} nodeId={id} index={index}
                                                         isVis={active}/>)}

        {active && <button onClick={addData} className="PlusButton">+</button>}
        {active && <button onClick={removeData} className="PlusButton2">-</button>}
    </div>

    );
};

export default Player;